import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
/**
 * Getters
 */
export const _RealmGetter = Getter.of();
export const _RealmsGetter = Getter.of();
export const _RealmsResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _RealmsResponse2Realms = Fold.mapF((res) => Res.map((x) => x.data, res));
export const _Realms2Realm = Fold.compose(_RealmsGetter, Res._ForEach());
export const _Realm2Data = Fold.compose(_RealmGetter, Res._Response());
export const _Realm2Attributes = Fold.compose(_Realm2Data, Lens.prop("attributes"));
export const _RealmAttributes2SonicBaseUrl = Fold.compose(_Realm2Attributes, Lens.prop("sonicBaseUrl"));
export const _RealmAttributes2Brand = Fold.compose(_Realm2Attributes, Lens.prop("brand"));
export const _RealmAttributes2Recommended = Fold.compose(_Realm2Attributes, Lens.prop("recommended"));

